// extracted by mini-css-extract-plugin
export default {"wrapper":"FixedBottomBanner-module__wrapper--mYwTP","animatedBackground":"FixedBottomBanner-module__animatedBackground--rwGec"};